import Validator from 'validatorjs';
import { toMcpToolNameSlug } from '@kentik/ui-shared/kaizen/mcpToolNameSlug';
import $mcpServers from 'app/stores/ai/$mcpServers';

export function registerMcpServerValidators() {
  Validator.register(
    'uniqueMcpServerName',
    function uniqueMcpServerName(value) {
      const { id } = this.validator.input;
      const slug = toMcpToolNameSlug(value);
      const match = $mcpServers.collection.find(
        (m) => m.get('name') === value || (slug && toMcpToolNameSlug(m.get('name')) === slug)
      );

      return !match || match.get('id') === id;
    },
    'This name is too similar to an existing MCP server'
  );
}
